import React, { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../ButtonRound';
import styles from './Modal.scss';
import HouseDoiIcon from '../../assets/img/houseDoi.svg';
import UserRequest from '../../utils/UserRequest';
import Config from '../../utils/Config';

const userApiUrl = Config.get('userApi.url');

const WelcomeText = ({ nextStep, values, setSalt, setCode }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorList, setErrorList] = useState([]);

    const handleSendVerificationCode = (ev: React.FormEvent) => {

        ev.preventDefault();
        setIsLoading(true);
        return UserRequest.postRequest(userApiUrl + '/user-api/user/doi?_format=json', {
            method: 'mail',
            action: 'send',
            mail: values.mail
        }, { timeout: 60000 })
            .then((res) => {
                // success
                setIsLoading(false);
                const data = res.getData();
                setSalt(data.data.salt);
                setCode('');
                goToNextStep(ev);
            })
            .catch((e) => {
                // reset state on error
                setIsLoading(false);
                const errorList = [];
                errorList.push({ id: 'mail', text: 'Die E-Mail konnte nicht gesendet werden.', fields: ['mail'] });
                setErrorList(errorList);

                return Promise.reject(e);
            });
    };

    const goToNextStep = e => {
        e.preventDefault();
        nextStep();
    }

    return (
        <div>
            <DialogContent dividers={false}>
                <div className={styles.welcomeTextContainer}>
                    <div>
                        <HouseDoiIcon />
                    </div>
                    <div>
                        <p>Zum Schutz von dir und anderen Nutzenden möchten wir sicherstellen, dass du es wirklich bist. Dazu bitten wir dich, deine E-Mail-Adresse zu verifizieren.</p><br></br>
                        <p>Wir geben deine E-Mail-Adresse nicht weiter und veröffentlichen diese nicht.</p>
                    </div>
                </div>
                {errorList
                    .filter((e) => e.id === 'mail')
                    .map((e) => (
                        <p className={styles.error} key={e.text}>
                            {e.text}
                        </p>
                    ))}
                <div className={styles.mailButtons}>
                    <ButtonRound type="submit" className={'button button--primary'} isLoading={isLoading} onClick={handleSendVerificationCode}>
                        Weiter
                    </ButtonRound>
                </div>
            </DialogContent>
        </div>
    )
}

export default WelcomeText